import React from 'react';
import loader from 'assets/loader.gif';

const Loader = () => (
  <div style={{
    alignItems: 'center', display: 'flex', justifyContent: 'center', padding: '7rem  0',
  }}
  >
    <img alt='loading' src={loader} />
  </div>
);

export default Loader;
